<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="modal-container"
  (onHide)="onClose()"
  [draggable]="false"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <h2>Please Select User Role</h2>
    </div>
  </ng-template>

  <div class="role-list">
    <div
      class="role-option"
      *ngFor="let role of roles"
      [class.selected]="selectedRole === role"
      (click)="selectRole(role)"
    >
      <div class="radio-icon-wrapper">
        <div class="radio-icon" *ngIf="selectedRole === role">✓</div>
      </div>
      <div class="role-label">{{ role }}</div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="btn cancel" type="button" pButton (click)="onClose()">
      Cancel
    </button>
    <button class="btn continue" type="submit" pButton (click)="onContinue()">
      Continue
    </button>
  </ng-template>
</p-dialog>
